import BankList from './bank-list';

export default BankList;
